import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { getCourseById, updateCourse } from '../redux/httpRequests';
import NonImage from '../Images/image.png';
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import app from '../services/firebase';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import { resetLoading, setLoading } from '../redux/loadingSlice';
import TextField from '@mui/material/TextField';
import ConfirmationModal from '../components/ConfirmationModal';
import SwitchToggle from '../components/SwitchToggle';
import { mobile } from '../responsive';
//actualiza
const Container = styled.div`
  width: 80vw; height: 80vh; display:flex; justify-content:center; align-items:center; position:relative;
  ${mobile({width:'100vw', height:'auto', padding:'16px'})}
`;
const SingleContainer = styled.div` display:flex; height:90%; ${mobile({flexDirection:'column'})} `;
const Left = styled.div` flex:1; height:90%; margin-top:20px; `;
const Right = styled.div` flex:2; height:90%; margin-top:20px; `;
const ImgContainer = styled.div`
  box-shadow: 0 0 10px 2px rgba(161,161,161,.61); border-radius:10px; height:100%;
  padding: 40px; margin-right:20px; margin-top:20px; display:flex; justify-content:center; flex-direction:column; gap:20px;
  ${mobile({boxShadow:'none', padding:'0', marginRight:'0', width:'100%'})}
`;
const Img = styled.img`
  width: 380px; height: 240px; border-radius: 10px; object-fit: cover; cursor: pointer;
  &:hover{ box-shadow: 0 0 10px 2px rgba(33,110,140,.65); }
`;
const ImgInputF = styled.input` display:none; `;
const Form = styled.form`
  box-shadow: 0 0 10px 2px rgba(161,161,161,.61); border-radius:10px; height:100%;
  padding: 40px; margin-right:20px; margin-top:20px; width: 40vw; display:flex; justify-content:center;
  ${mobile({boxShadow:'none', width:'100%', padding:'0'})}
`;
const FormContainer = styled.div` width: 30vw; ${mobile({width:'100%'})} `;
const BackButton = styled.button`
  display:flex; background:transparent; border:none; position:absolute; top:15px; left:15px; cursor:pointer;
`;
const ConfirmButton = styled.button`
  margin-top: 30px; width: 150px; padding: 10px; border: none; background: teal; color:white; font-weight:bold; cursor:pointer;
`;

export default function CourseSingle() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector((s) => s.loading.isLoading);
  const location = useLocation();
  const id = location.pathname.split('/')[2];

  const current = useSelector((s) => s.course.current);
  const [course, setCourse] = useState(null);
  const [thumbFile, setThumbFile] = useState(null);
  const [open, setOpen] = useState(false);
  const [formError, setFormError] = useState({ set:false, message:'' });
  
  useEffect(() => { dispatch(getCourseById(id)); }, [dispatch, id]);
  useEffect(() => { if (current) setCourse(current); }, [current]);

  const onChange = (e) => setCourse(prev => ({ ...prev, [e.target.name]: e.target.value }));
  const onToggleStatus = (_, bool) => setCourse(prev => ({ ...prev, status: bool ? 'active' : 'inactive' }));
  const onToggleDiscount = (_, bool) => setCourse(prev => ({ ...prev, discount: bool, discountAmount: bool ? (prev.discountAmount || 0) : 0 }));

  
  const uploadThumbnailIfNeeded = async () => {
    if (!thumbFile) return null;
    const storage = getStorage(app);
    const fileName = `${Date.now()}_${thumbFile.name}`;
    const storageRef = ref(storage, fileName);
    const uploadTask = uploadBytesResumable(storageRef, thumbFile);
    const url = await new Promise((resolve, reject) => {
      uploadTask.on('state_changed', () => {}, reject, () => {
        getDownloadURL(uploadTask.snapshot.ref).then(resolve).catch(reject);
      });
    });
    return url;
  };

  const errorCheck = () => {
    if (!course?.title || !course?.description || !course?.duration || !course?.price || !course?.dolarPrice) return true;
    return false;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (errorCheck()) return setFormError({ set:true, message:'Faltan campos requeridos' });

    dispatch(setLoading());
    try {
      const newThumb = await uploadThumbnailIfNeeded();
      const payload = { ...course };
      if (newThumb) payload.thumbnail = newThumb;

      await dispatch(updateCourse({ id: course._id, course: payload }));
      navigate('/courses');
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(resetLoading());
      setOpen(false);
    }
  };

  if (!course) return null;

  return (
    <Container>
      <BackButton onClick={() => navigate('/courses')}><ChevronLeftIcon style={{fontSize:30}}/></BackButton>
      <SingleContainer>
        <Left>
          <ImgContainer>
            <label htmlFor="thumb">
              <Img src={thumbFile ? URL.createObjectURL(thumbFile) : (course.thumbnail || NonImage)} alt="thumb" />
            </label>
            <ImgInputF id="thumb" type="file" onChange={(e) => setThumbFile(e.target.files?.[0] || null)} />
          </ImgContainer>
        </Left>

        <Right>
          <Form onSubmit={(e) => e.preventDefault()}>
            <FormContainer>
              <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>
                <TextField name="title" label="Título" value={course.title || ''} onChange={onChange} required />
                <TextField name="description" label="Descripción" value={course.description || ''} onChange={onChange} required multiline rows={4} />
                <TextField name="duration" label="Duración (min)" type="number" value={course.duration || ''} onChange={onChange} required />
                <TextField name="price" label="Precio ($)" type="number" value={course.price || ''} onChange={onChange} required />
                <TextField name="dolarPrice" label="Precio USD" type="number" value={course.dolarPrice || ''} onChange={onChange} required />

                <div style={{ display:'flex', alignItems:'center', gap:16 }}>
                  <span>Activo</span>
                  <SwitchToggle inStock={course.status === 'active'} id={course._id} fn={onToggleStatus} />
                </div>

                <div style={{ display:'flex', alignItems:'center', gap:16 }}>
                  <span>Descuento</span>
                  <SwitchToggle inStock={!!course.discount} id={course._id} fn={onToggleDiscount} />
                  <TextField
                    name="discountAmount" label="%" type="number" inputProps={{ min:0, max:99 }}
                    disabled={!course.discount}
                    value={course.discount ? (course.discountAmount || '') : ''}
                    onChange={(e) => setCourse(prev => ({ ...prev, discountAmount: +e.target.value }))}
                    style={{ width:90 }}
                  />
                </div>

                {formError.set ? <p style={{color:'red'}}>{formError.message}</p> : null}

                {loading
                  ? <ConfirmButton disabled style={{cursor:'default', background:'lightgray'}}>
                      <Stack sx={{ color: 'white', display:'flex', justifyContent:'center' }} spacing={0} direction="row">
                        <CircularProgress size="1rem" color="inherit" />
                      </Stack>
                    </ConfirmButton>
                  : <ConfirmationModal
                      open={open}
                      close={() => setOpen(false)}
                      children={<ConfirmButton type="button" onClick={() => setOpen(true)}>Actualizar</ConfirmButton>}
                      title="Modificar"
                      text="¿Seguro que deseas modificar este curso?"
                      fn={onSubmit}
                    />
                }
              </div>
            </FormContainer>
          </Form>
        </Right>
      </SingleContainer>
    </Container>
  );
}